import ApiService from '../util/apiService';
import * as ActionType from './types/ProductDetailPageActionTypes';

const requestRecommendedProducts = () => ({
  type: ActionType.REQUEST_RECOMMENDED_PRODUCTS,
});

const requestRelatedProducts = () => ({
  type: ActionType.REQUEST_RELATED_PRODUCTS,
});

const receivedRecommendedProducts = (response) => ({
  type: ActionType.RECEIVED_RECOMMENDED_PRODUCTS,
  payload: response,
});

const receivedRelatedProducts = (response) => ({
  type: ActionType.RECEIVED_RELATED_PRODUCTS,
  payload: response,
});

export const fetchRecommendedProducts = (data) => (dispatch) => {
  dispatch(requestRecommendedProducts());
  return ApiService.post('/web-store-api/v1/overview/product/get-recs', data).then((json) =>
    dispatch(receivedRecommendedProducts(json))
  );
};

export const fetchRelatedProducts = (data) => (dispatch) => {
  dispatch(requestRelatedProducts());
  const { productId } = data;
  return ApiService.get(`/web-store-api/v1/product/find-related/${productId}`).then((json) =>
    dispatch(receivedRelatedProducts(json))
  );
};
